import React from "react";
import { Typography as CoreView } from "@jelly/ui";

import defaultStyle from "./Typography.module.scss";

export const Typography: React.FC<React.ComponentProps<typeof CoreView>> = (props) => {
  return <CoreView {...props} style={defaultStyle} />;
};
